import React from 'react';
import { Subscribe } from 'unstated';
import InvoiceDataContainer from '../Stores/InvoiceDataContainerStore';
import PaymentDataContainer from '../Stores/PaymentDataContainerStore';
import myGlobals from '../Utils/globals';
import onlinePaymentsIntermediate from '../Utils/onlinePaymentsIntermediate';
import LoadingUtility from '../Utils/LoadingUtility';
import AjaxUtil from '../Utils/AjaxUtil';

class PaypalPayment extends React.Component {
    render() {
        return (
            <Subscribe to={[InvoiceDataContainer]}>
                {invData => (
                    <div className="trustly-container centered-container">
                        {this.setInvoiceData(invData)}
                        {this.renderLoading()}
                    </div>
                )}
            </Subscribe>
        )
    }

    constructor(props) {
        super(props);
        this.state = AjaxUtil.getDefaultState();
        this.setData = AjaxUtil.stateSetter.bind(this);
        this.invData = null;
    }

    setInvoiceData = (invData) => {
        this.invData = invData;
    }

    renderLoading = () => {
        if (this.state.isLoading) {
            return <LoadingUtility id="PAYPAL" name="paypal"></LoadingUtility>
        } else {
            this.processResponse();
        }
    }

    processResponse = () => {
        if (this.state.hasError) {
            console.log("Error");
        } else {
            onlinePaymentsIntermediate.response = this.state.data;
            myGlobals.selectedStateMethodPaymentContainer('IFRAMEDI');
        }
    }

    componentDidMount() {
        //this.invData.state.paymentOnAccount = true;
        console.log("paymentOnAccount flag is" + this.invData.state.paymentOnAccount);
        if(this.invData.state.paymentOnAccount){
            const searchParams = new URLSearchParams();
            searchParams.append('paymentMethod', this.props.paymentMethod);
            searchParams.append('onDemandAccountId', this.invData.state.onDemandAccountId);
            searchParams.append('customerMapId', this.invData.state.pkMcarId);
            searchParams.append('currency', this.invData.state.currency);
            searchParams.append('paymentAmount', this.invData.state.payableAmount);
            searchParams.append('globalAccountId',this.invData.state.globalAccountId);
            searchParams.append('token', myGlobals.token);
            searchParams.append('publicKey', this.invData.state.publicKey);
            if(this.invData.state.remittanceFormData!==null){
                const keys = Object.keys(this.invData.state.remittanceFormData);
                for(let i=0;i<keys.length;++i){
                    searchParams.append(keys[i],(this.invData.state.remittanceFormData[keys[i]]));
                }
              }
            let link = "invokePaypalPaymentOnAccount";
            //let link = "https://api.jsonbin.io/b/5f05af36a62f9b4b27611c16";
            AjaxUtil.loadData(link, searchParams, this.setData);
        }
        else{
            let invoiceNumberAndAmount = '';
            this.invData.state.selectedInvoices.forEach((invoice) => {
                invoiceNumberAndAmount += invoice.accountDocHeaderId + '@' + invoice.payableAmount2 + '@' + invoice.disputeAmount + '@' + invoice.reasonCodeId + ','
            });
            invoiceNumberAndAmount = invoiceNumberAndAmount.substring(0, invoiceNumberAndAmount.length - 1);
            const searchParams = new URLSearchParams();
            searchParams.append('paymentMethod', this.props.paymentMethod);
            searchParams.append('invoiceNumbers', invoiceNumberAndAmount);
            searchParams.append('onDemandAccountId', this.invData.state.onDemandAccountId);
            searchParams.append('customerMapId', this.invData.state.pkMcarId);
            searchParams.append('currency', this.invData.state.currency);
            searchParams.append('paymentAmount', this.invData.getTotalInvoiceAmount(this.invData.state.selectedInvoices));
            searchParams.append('globalAccountId',this.invData.state.globalAccountId);
            searchParams.append('pkMapCustomerAccountRad',this.invData.state.pkMcarId);
            //searchParams.append('countryCode',this.state.selectedValue);
            searchParams.append('token', myGlobals.token);
            searchParams.append('publicKey', this.invData.state.publicKey);
            let link = "invokePaypalPayment";
            AjaxUtil.loadData(link, searchParams, this.setData);
        }
    }

}

export default PaypalPayment;